export function scrollToTopHelper() {
  return window.scrollTo(0, 0);
}
